<main class="main">
  <app-simulator-card [header]="'¡Ups!'" [showHeader]="true">
    <div slot="body">
      <div class="error-content">
        <div class="error-message">
          <img
            [src]="'assets/images/error-404.svg' | brandAsset"
            alt="Error 404"
            class="error-image"
          />
          <p class="error-text">No encontramos la página que estás buscando.</p>
        </div>
        <div class="cta">
          <app-pill-button variant="primary" (clicked)="goHome()"
            >Volver al inicio</app-pill-button
          >
        </div>
      </div>
    </div>
  </app-simulator-card>
</main>
